import request from '@/utils/request'

/** 根据角色key查询用户列表 */
export function getUserListByRoleKey(roleKey) {
  return request({
    url: '/system/user/getUserListByRoleKey/' + roleKey,
    method: 'get'
  })
}

/** 简易用户列表 */
export function simpleListUser(query) {
  return request({
    url: '/system/user/simpleList',
    method: 'get',
    params: query
  })
}

/** 根据菜单权限查询用户列表 */
export function getUserListByMenuPerms(params) {
  return request({
    url: '/system/user/getUserListByMenuPerms',
    method: 'get',
    params
  })
}

/** 查询教师列表 */
export function getTeacherList() {
  return getUserListByRoleKey('teacher')
}
